import { render } from "./TheOnboarding.vue?vue&type=template&id=55edc3ca&scoped=true&ts=true"
import script from "./TheOnboarding.vue?vue&type=script&lang=ts"
export * from "./TheOnboarding.vue?vue&type=script&lang=ts"

import "./TheOnboarding.vue?vue&type=style&index=0&id=55edc3ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.38_typescript@5.9.3__webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55edc3ca"]])

export default __exports__